import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { IBackBtn } from '~/views/types';

export const BackBtn: FC<IBackBtn> = props => {
    const navigate = useNavigate();
    const goBack = () => {
        if (props.beforeGoBack) {
            props.beforeGoBack();
        }
        navigate(props.path);
    };

    return (
        <div className="go-back">
            <div className="go-back-btn-wrap">
                <button id="go-back-btn" type="button" className="btn" onClick={goBack}>
                    <img src="/assets/img/arrow-left.svg" />
                    <span>Go back</span>
                </button>
            </div>
        </div>
    );
};
